<template>
  <main class="register">
    <section class="wrapper section">
      <form-internal-register />
    </section>
  </main>
</template>

<script>
import FormInternalRegister from '@/components/forms/internal-register/FormInternalRegister.vue';

export default {
  name: 'internal-register',
  components: { FormInternalRegister },
  mounted() {
    if (process.env.VUE_APP_ENV === 'production') {
      window.fbq('track', 'PageView');
    }
  }
};
</script>
